	/**
 * Main.js
 *
 * Fusion FE Framework Main script file
 */

/*jslint node: true */
'use strict';

window.StackTrace = require('stacktrace-js');

// Assigned Dependencies
var $ = require('jquery');
var _ = require('underscore');
var AOS = require('aos');
var Rellax = require('rellax');

var x=1;

require('mediaMatch');
require('jquery-actual');

var IsotopeLayout = require('isotope-layout');
require('isotope-packery');

var enquire = require('enquire');
var Scrollbar = require('smooth-scrollbar');
var TweenMax = require('gsap');

// // Expose jQuery on the window.
window.$ = $;
window._ = _;
window.enquire = enquire;
window.IsotopeLayout = IsotopeLayout;
window.Scrollbar = Scrollbar;
window.TweenMax = TweenMax;
window.AOS = AOS;
window.Rellax = Rellax;

// Define LCB namespace
window.lcb = {};
window.lcb.config = {};
window.lcb.module = {};
window.lcb.constant = {};

// Core
require('foundation');

// Utils
require('foundation-media');
require('foundation-box');
require('foundation-keyboard');
require('foundation-triggers');
require('foundation-motion');
require('foundation-imageLoader');

// Plugins
require('foundation-accordion');
require('foundation-reveal');
require('foundation-tooltip');
require('foundation-equalizer');

require('foundation-datepicker');

require('motion-ui');

require('ajaxupload');
require('Modernizr');
require('itemslide');
require('blockui');

require('magnific-popup');

/* map script */
require('ammap');
require('ammapContinent');

window.moment = require('moment');
window.moment.defineLocale('zh', { parentLocale: 'zh-cn' });
window.moment.defineLocale('mx', { parentLocale: 'es' });

window.AutoNumeric = require('autonumeric');

require('combodate');

$(document).ready(function() {
	require('full-screen-form');
});

$(document).foundation();

require('./components/default');
require('./components/lcb-config');
require('./components/lcb-global');
require('./components/lcb-constant');

window.lcb.module.shortCoursesFilter = require('./components/short-course-filter');
window.lcb.module.programFilter = require('./components/program-filter');
window.lcb.module.brochurefilter = require('./components/brochure-filter');
window.lcb.module.newsFilter = require('./components/news-filter');
window.lcb.module.itemSlide = require('./components/itemslide');

require('./components/forms');
require('./components/footer');
require('./components/navigation');
require('./components/sliders');
require('./components/contact');
require('./components/schoolbag');
require('./components/short-course');
require('./components/courses');
require('./components/list-filters');
require('./components/full-height-content-block');
require('./components/gallery');
require('./components/font-scale');
require('./components/form-builder');
require('./components/locationmap');
require('./components/ind-placement-questionnaire');
require('./components/analytics');
require('./components/video');
require('./components/search');
require('./components/calendar');
require('./components/horizontal-scroll');
require('./components/animation');

require('./components/dev');
